import { useContext, useMemo } from 'react';
import { GlobalUIContext } from 'contexts/GlobalUIContext';

export function useLeaderboardStickyTop(): number {
  const globalUI = useContext(GlobalUIContext);

  return useMemo(() => {
    const bannerOffset = 0;
    return (globalUI.headerHeight ?? 80) + bannerOffset;
  }, [globalUI.headerHeight]);
}

export const LEADERBOARD_HERO_MOBILE_EXTRA_TOP = 56;
export const LEADERBOARD_HERO_DESKTOP_EXTRA_TOP = 80;

export function useLeaderboardHeroPaddingTop(): {
  mobile: number;
  desktop: number;
} {
  const stickyTop = useLeaderboardStickyTop();
  return {
    mobile: stickyTop + LEADERBOARD_HERO_MOBILE_EXTRA_TOP,
    desktop: stickyTop + LEADERBOARD_HERO_DESKTOP_EXTRA_TOP,
  };
}
